import { render, staticRenderFns } from "./NewsPost.vue?vue&type=template&id=7ad599ac&"
import script from "./NewsPost.vue?vue&type=script&lang=js&"
export * from "./NewsPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports